import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Avatar, Timeline, Divider, Alert, Card, Modal } from 'antd';
import prescription from '../../Images/Pres.png';
import health from '../../Images/HealthIcon.png';
import pink from '../../Images/pink.png';
import red from '../../Images/red.png';
import prescriptionIcon from '../../Images/Lab.png';
import file from '../../Images/File.png';
import goBtn from '../../Images/GoButton.png';
// import noProfile from '../../Images/noProfile.png';
import { BodyTextHeadingAppointment, ModalData, ModalHeading, ModalTittle, TableHeading } from '../CommonText';

import './style.css';
import { selectedHealthRecData, selectedPrescriptionData, selectLoading, selectPassportData } from './Selectors';
import { passportFileOpenRequest, passportRequest, selectedHealthRecIdRequest, selectedPrescriptionIdRequest } from './Actions';
import { Content } from 'antd/es/layout/layout';
import CustomSpin from '../CommonSpin';
import format from 'date-fns/format';
import moment from 'moment';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';
import { useNavigate } from 'react-router-dom';

const Passport = () => {
    // const [state, setState] = useState({
    //     currentPage: 1,
    //     visible: false,
    //     items: Array.from({ length: 1 }),
    //     hasMore: true,
    //     clickedFlag: false,
    //     visibleHeal: false,
    //     visibleLab: false,
    // });

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [visiblePrescription, setVisiblePrescription] = useState(false);
    const [visibleHeal, setVisibleHeal] = useState(false);

    const passport = useSelector(selectPassportData);
    const requesting = useSelector(selectLoading);
    // const clickedId = [];
    // const clickedIdHealth = useSelector(makeSelectClickedIdHealth());
    // const clickedIdLab = useSelector(makeSelectClickedIdLab());
    // const isPagination = useSelector(makeSelectIsPage());
    const prescriptionData = useSelector(selectedPrescriptionData);
    const healthrecord = useSelector(selectedHealthRecData);

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    const patientId = sessionStorage.getItem('PATIENT_ID');    
    
    useEffect(() => {
        if (!patientId) {
            Modal.warning({
                title: 'Complete your profile',
                content: 'Please complete your profile details here...',
            });
            navigate('/addprofile');
        }
    },[]);

    useEffect(() => {
        dispatch(passportRequest());
    }, [dispatch]);

    const handleCard = () => {
        setVisiblePrescription(true);
    };

    const handleOk = () => {
        setVisiblePrescription(false);
    };

    const handleCancel = () => {
        setVisiblePrescription(false);
    };

    const handleOkHeal = () => {
        setVisibleHeal(false);
    };

    const handleCancelHeal = () => {
        setVisibleHeal(false);
    };

    const handleCardHeal = () => {
        setVisibleHeal(true);
    };

    let body = [];
    let PrescriptionBody = '';
    let labCount = null;
    let prescCount = null;
    let healthCount = null;
    let prescriptionRecBody = [];
    // let labrecBody = [];
    let healthRecBody = [];

    if (passport && passport !== null) {
        const passBody = passport && passport.passport;
        for (const key in passBody) {
            const passBodySub = passBody[key];
            for (const heading in passBodySub) {
                if (heading === 'prescriptions') {
                    const quikdrPrescription = passBodySub[heading].map((item) => {
                        // if (item.organisationsId === 1 || item.organisationsId === 140) {
                        return item;
                        // }
                        // return 1;
                    });
                    const prescriptionBody = quikdrPrescription;
                    const prescriptionFilteredData = prescriptionBody.filter(item => typeof item === 'object' && !Array.isArray(item));
                    prescCount = prescriptionFilteredData.length;
                    prescriptionRecBody = prescriptionBody.map((item) => {

                        if (item != 1) {
                            return (
                                <div
                                    onClick={() => {
                                        dispatch(selectedPrescriptionIdRequest(item.id));
                                    }}
                                    key={item.id}
                                    style={{ cursor: 'pointer' }}
                                    onClickCapture={handleCard}
                                >
                                    <Timeline.Item style={{ margin: '10px', }}  dot={<Avatar size={25} icon="user" src={red} style={{ marginLeft: '-4px', marginTop: '15px' }} />}>
                                        {/* <div className="cardHealthAndPrescription" /> */}
                                        <Col 
                                            xxl={{ span: 8 }}
                                            xl={{ span: 12 }}
                                            lg={{ span: 14 }}
                                            md={{ span: 18 }}
                                            sm={{ span: 20}}
                                            xs={{ span: 19 }}
                                            className="cardHealthAndPrescriptionSub" style={{width:'100%'}}>
                                            <Row >
                                                <Col
                                                    span={2}
                                                    style={{
                                                        background: '#FF9234',
                                                        // paddingBottom: ' 10px',
                                                        borderRadius: '8px 0px 0px 8px',
                                                        minWidth:'10px',
                                                        maxWidth:'20px'
                                                    }}
                                                >
                                                    <div className="recordHeading">&nbsp;&nbsp;{' '}</div>
                                                    <div className="healthHeading">{`${langdata.langdata ? langdata.Prescriptions :  'Prescriptions' }`}</div>
                                                    <div className="myHeading">&nbsp;</div>

                                                </Col>
                                                {/* <Col span={23} style={{ background: '#ffff',marginLeft: '15px', }}> */}
                                                {/* <Col
                                                            style={{ background: '#ffff', marginTop: '10px', marginLeft: '15px', }}
                                                            span={19}
                                                        > */}
                                                {/* <Row> */}
                                                <Col span={8} style={{ margin: '20px', marginTop: '30px' }}>
                                                    <div className="normalHeading">
                                                        <TableHeading text = {`${langdata.PrescribedBy ? langdata.PrescribedBy : 'Prescribed By' }`} color = '#4F4F4F' />
                                                    </div>
                                                    <div className="boldheading" style={{ marginBottom: '20px' }}>
                                                        <BodyTextHeadingAppointment text = {`${item.doctorFirstName} ${item.doctorLastName}`} />
                                                    </div>
                                                    <div className="normalHeading" >
                                                        <TableHeading text = {`${langdata.CreatedBy ? langdata.CreatedBy : 'Created By' }`} color = '#4F4F4F'/>
                                                    </div>
                                                    <div className="boldheading" >
                                                        <BodyTextHeadingAppointment text ={item.createdByOrgName} />
                                                    </div>
                                                </Col>
                                                <Col span={7} style={{ margin: '20px', marginTop: '30px' }}>
                                                    <div className="normalHeading">
                                                        <TableHeading text = {`${langdata.PatientName ? langdata.PatientName : 'Patient Name' }`} color = '#4F4F4F'/>
                                                    </div>
                                                    <div className="boldheading" style={{ marginBottom: '20px' }}>
                                                        <BodyTextHeadingAppointment text = {`${item.firstName} ${item.lastName}`} /> 
                                                    </div>
                                                    <div className="normalHeading">
                                                        <TableHeading text = {`${langdata.PrescribedOn ? langdata.PrescribedOn : 'Prescribed On' }`} color = '#4F4F4F' />
                                                    </div>
                                                    <div className="boldheading" >
                                                        <BodyTextHeadingAppointment text ={item.createdDate} />
                                                    </div>
                                                </Col>
                                                {/* </Col> */}
                                                <Col 
                                                    xs={{ span: 0 }}
                                                    sm={{ span: 0}}
                                                    xxl={{ span: 2 }}
                                                    xl={{ span: 2 }}
                                                    lg={{ span: 2 }}
                                                    md={{ span: 2 }}
                                                    span={2} style={{ background: '#fff', borderRadius: '12px', margin: '20px' }}>
                                                    <div
                                                        style={{
                                                            paddingTop: '34px',
                                                            // paddingLeft: '25%',
                                                            paddingBottom: '35px',
                                                        }}
                                                    >
                                                        <Avatar shape="square" size={50} icon="user" src={goBtn} />
                                                    </div>
                                                </Col>
                                            </Row>
                                            {/* </Col>
                                                </Row> */}
                                        </Col>
                                    </Timeline.Item>
                                </div>
                            );
                        }
                    });
                }
                if (heading === 'healthrecords') {
                    const quikdrHealthRecords = passBodySub[heading].map((item) => {
                        // if (item.organisationsId === 1 || item.organisationsId === 140) {
                        return item;
                        // }
                        // return 1;
                    });
                    const healthBody = quikdrHealthRecords;
                    const healthBodyFilteredData = healthBody.filter(item => typeof item === 'object' && !Array.isArray(item));
                    healthCount = healthBodyFilteredData.length;
                    healthRecBody = healthBody.map((item) => {
                        if (item != 1) {
                            return (
                                <div
                                    onClick={() => {
                                        dispatch(selectedHealthRecIdRequest(item.id));
                                    }}
                                    key={item.id}
                                    style={{ cursor: 'pointer' }}
                                    onClickCapture={handleCardHeal}
                                >
                                    <Timeline.Item
                                        style={{ margin: '10px', }}
                                        dot={<Avatar size={25} icon="user" src={pink} style={{ marginLeft: '-4px', marginTop: '25px', }} />}>
                                        <Col 
                                            xxl={{ span: 8 }}
                                            xl={{ span: 12 }}
                                            lg={{ span: 14 }}
                                            md={{ span: 18 }}
                                            sm={{ span: 20}}
                                            xs={{ span: 19 }}
                                            className="cardHealthAndPrescriptionSub" style={{width:'100%'}}>

                                            <Row>
                                                <Col
                                                    xs={{ span: 2 }}
                                                    sm={{ span:2 }}
                                                    xxl={{ span: 2 }}
                                                    xl={{ span: 2 }}
                                                    lg={{ span: 2 }}
                                                    md={{ span: 2 }}
                                                    style={{
                                                        background: '#FD0054',
                                                        paddingBottom: ' 16px',
                                                        borderRadius: '8px 0px 0px 8px',
                                                        minWidth:'10px',
                                                        maxWidth:'20px'
                                                    }}
                                                >
                                                    <div className="recordHeading">{`${langdata.Records ? langdata.Records : 'Records' }`}</div>
                                                    <div className="healthHeading">{`${langdata.Health ? langdata.Health : 'Health' }`}</div>
                                                    <div className="myHeading">{`${langdata.My ? langdata.My : 'My' }`}</div>
                                                </Col>
                                                {/* <Col span={23} style={{ background: '#ffff',marginLeft: '15px', }}> */}
                                                {/* <Col
                                                            style={{ background: '#ffff', marginTop: '10px', marginLeft: '15px', }}
                                                            span={19}
                                                        > */}
                                                {/* <Row> */}
                                                <Col
                                                    xs={{ span: 8 }}
                                                    sm={{ span: 8}}
                                                    xxl={{ span: 8 }}
                                                    xl={{ span: 8 }}
                                                    lg={{ span: 8 }}
                                                    md={{ span: 8 }} 
                                                    style={{ margin: '25px', marginTop: '30px' }}>
                                                    <div className="normalHeading">
                                                        <TableHeading text = {`${langdata.RecordName ? langdata.RecordName : 'Record Name' }`} color = '#4F4F4F'/>
                                                    </div>
                                                    <div className="boldheading" style={{ marginBottom: '20px' }}>
                                                        <BodyTextHeadingAppointment text = {item.healthRecType} />
                                                    </div>
                                                    <div className="normalHeading">
                                                        <TableHeading text = {`${langdata.CreatedBy ? langdata.CreatedBy : 'Created By' }`} color = '#4F4F4F'/>
                                                    </div>
                                                    <div className="boldheading">
                                                        <BodyTextHeadingAppointment text = {item.createdByOrgName} />
                                                    </div>
                                                </Col>
                                                <Col 
                                                    xs={{ span: 5 }}
                                                    sm={{ span: 5}}
                                                    xxl={{ span: 5 }}
                                                    xl={{ span: 5 }}
                                                    lg={{ span: 5 }}
                                                    md={{ span: 5 }}
                                                    span={5} style={{ margin: '25px', marginTop: '30px' }}>
                                                    <div className="normalHeading">
                                                        <TableHeading text = {`${langdata.PatientName ? langdata.PatientName : 'Patient Name' }`} color = '#4F4F4F'/>
                                                    </div>
                                                    <div
                                                        className="boldheading"
                                                        style={{ marginBottom: '20px' }}
                                                    >
                                                        <BodyTextHeadingAppointment text = {`${item.firstName} ${item.lastName}`} />
                                                    </div>
                                                    <div className="normalHeading">
                                                        <TableHeading text = {`${langdata.DoneOn ? langdata.DoneOn : 'Done On' }`} color = '#4F4F4F'/>
                                                    </div>
                                                    <div className="boldheading">
                                                        <BodyTextHeadingAppointment text = {item.createdDate} />
                                                    </div>
                                                </Col>
                                                {/* </Col> */}
                                                <Col 
                                                    xs={{ span: 0 }}
                                                    sm={{ span: 0}}
                                                    xxl={{ span: 2 }}
                                                    xl={{ span: 2 }}
                                                    lg={{ span: 2 }}
                                                    md={{ span: 2 }}
                                                    style={{ background: '#fff', borderRadius: '12px', margin: '20px', marginTop : '30px' }}>
                                                    <div
                                                        style={{
                                                            paddingTop: '34px',
                                                            paddingLeft: '25%',
                                                            paddingBottom: '35px',
                                                        }}
                                                    >
                                                        <Avatar shape="square" size={50} icon="user" src={goBtn} />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Timeline.Item>
                                    <div />
                                </div>
                            );
                        }
                    });
                }
            }
            body.push(
                <div style={{ background: '#FAFAFA' }} key={key}>
                    <Row type="flex" justify="center">
                        <Col md={{ span: 24 }} xs={{ span: 24 }} style={{ margin: '15px' }}>
                            {/* Date Block [mar 24] */}
                            <Row>
                                <Col md={{ span: 2, offset: 2 }} xs={{ span: 2, offset: 2 }}>
                                    <div className="dateBlock">
                                        <div className="dateBlock-month">
                                            {format(key, 'MMM')}
                                        </div>
                                        <br />
                                        <div className="dateBlock-day">
                                            {format(key, 'dd')}
                                        </div>{' '}
                                    </div>
                                </Col>

                                {/* Images */}
                                {/* <div style={{ marginTop: '0px' }}> */}
                                <Col md={{ span: 2, offset: 0 }} xs={{ span: 2, offset: 4 }}>
                                    <div>
                                        <div className="countBlock">{prescCount !== null ? prescCount : 0}</div>
                                        <div style={{ marginTop: '-21px' }}>
                                            <Avatar shape="square" size={56} icon="user" src={prescriptionIcon} />
                                        </div>
                                    </div>
                                </Col>
                                <Col md={{ span: 2, offset: 0 }} xs={{ span: 2, offset: 4 }}>
                                    <div>
                                        <div className="countBlock">{labCount !== null ? labCount : 0}</div>
                                        <div style={{ marginTop: '-21px' }}>
                                            <Avatar shape="square" size={56} icon="user" src={prescription} />{' '}
                                        </div>
                                    </div>
                                </Col>
                                <Col md={{ span: 2, offset: 0 }} xs={{ span: 2, offset: 4 }}>
                                    <div>
                                        <div className="countBlock">{healthCount !== null ? healthCount : 0}</div>
                                        <div style={{ marginTop: '-21px' }}>
                                            {' '}
                                            <Avatar shape="square" size={56} icon="user" src={health} />{' '}
                                        </div>
                                    </div>
                                </Col>
                                {/* </div> */}
                            </Row>
                        </Col>
                    </Row>
                    <Row type="flex" justify="center">
                        <Col
                            xxl={{ span: 24 }}
                            xl={{ span: 24 }}
                            lg={{ span: 24 }}
                            md={{ span: 24 }}
                            xs={{ span: 24 }}
                            // sm={{ span: 24}}
                            style={{ background: '#FAFAFA' }}
                        >
                            <Col
                                xxl={{ span: 24 }}
                                xl={{ span: 24 }}
                                lg={{ span: 24 }}
                                md={{ span: 24 }}
                                xs={{ span: 24 }}
                                sm={{ span: 24}}
                            >
                                <div style={{ paddingTop: '21px', paddingLeft: '12%'}}>
                                    {/* <Timeline style={{ display: 'block' }} pendingDot={false}> */}
                                    {prescriptionRecBody}
                                    {healthRecBody}
                                    {/* <Timeline.Item color="green" /> */}
                                    {/* </Timeline> */}
                                </div>
                            </Col>
                        </Col>
                    </Row>
                </div>
            );
        }
    }

    let HealthRecData = [];
    if (healthrecord && healthrecord[0] !== null) {
        const healthData = healthrecord && healthrecord[0].healthRecord;
        for (const i in healthData) {
            HealthRecData.push(
                <div key={i} style={{ paddingTop: '10px' }}>
                    <b>{i}</b> <Divider type="vertical" />
                    <a>{healthData[i]}</a>
                    <Divider style={{ marginTop: '5px', marginBottom: '-3px' }} />
                </div>,
            );
        }
    }

    if (prescriptionData && prescriptionData[0] !== null) {
        PrescriptionBody = '';
        if (prescriptionData[0]) {
            PrescriptionBody = prescriptionData[0].prescriptions.map(iitem => (
                <div key={iitem.id}>
                    <div style={{ float: 'left' }}>
                        <ModalData text = {iitem.medicine} />
                        <Divider type="vertical" />
                    </div>
                    <div>
                        <a className="pull-right">
                            <ModalData text = {iitem.intake} />
                        </a>
                    </div>
                    <Divider style={{ marginTop: '5px', marginBottom: '5px' }} />
                </div>
            ));
        }
    }

    return (
        <Content>
            <div style={{ marginBottom: '5%' }}>
                {body.length !== 0 ? (
                    <>
                        {body}
                    </>
                ) : (

                    <Col xs={{ span: 22 }} lg={{ span: 23 }} style={{ margin: '10px', marginLeft: '40px' }}>
                        <div style={{ textAlign: 'center' }}>
                            {/* <h1> */}
                            <Alert
                                message="No Data Available"
                                description="No data available for this patient"
                                type="info"
                            />
                            {/* </h1> */}
                        </div>
                    </Col>

                )}
            </div>
            <div>
                {/* Prescription Modal */}
                {prescriptionData && prescriptionData[0] !== null && (
                    <Modal
                        open={visiblePrescription}
                        className="bg-bgwhite"
                        onOk={handleOk}
                        onCancel={handleCancel}
                        width={650}
                        footer={false}
                        style={{ marginTop: '-10px' }}
                    >
                        <Row
                            style={{
                                background: '#FF9234',
                                height: '100px',
                                // width: '683px',
                                marginTop: '-20px',
                                marginRight: '-24px',
                                marginLeft: '-24px',
                                borderRadius: '8px 8px 0px 0px',
                                display: 'flex'
                            }}>
                            <Col
                                xs={{ span: 24 }}
                                lg={{ span: 24 }}
                            // style={{
                            //     background: '#FF9234',
                            //     height: '100px',
                            //     width: '683px',
                            //     marginTop: '-29px',
                            //     marginRight: '-50px',
                            //     marginLeft: '-24px',
                            //     borderRadius: '8px 8px 0px 0px',
                            // }}
                            >
                                <Row>
                                    <Col span={4} style={{ marginTop: '10px', marginLeft: '40px' }}>
                                        <Avatar
                                            size={80}
                                            icon="user"
                                            src={
                                                prescriptionData[0].profilephotourl === null
                                                    ? 'noProfile' // Provide your noProfile URL here
                                                    : prescriptionData[0].profilephotourl
                                            }
                                        />
                                    </Col>
                                    <Col span={12} style={{ marginTop: '10px' }}>
                                        <div
                                            style={{
                                                color: '#FFFFFF',
                                                // fontFamily: 'Roboto',
                                                fontSize: '25px',
                                                letterSpacing: '-0.41px',
                                            }}
                                        >
                                            <ModalHeading text ={`Dr. ${prescriptionData[0].doctorFirstName} ${prescriptionData[0].doctorLastName}`} color = '#ffffff' />
                                        </div>
                                        <div
                                            style={{
                                                color: '#FFFFFF',
                                                fontFamily: 'Roboto',
                                                fontSize: '15px',
                                                letterSpacing: ' -0.0016em',
                                            }}
                                        >
                                            <ModalData text = {prescriptionData[0].docdescriptions} color = '#ffffff'/>
                                        </div>
                                        <div
                                            style={{
                                                color: '#FFFFFF',
                                                fontFamily: 'Roboto',
                                                fontSize: '15px',
                                                letterSpacing: ' -0.0016em',
                                            }}
                                        >
                                            <ModalData text = {prescriptionData[0].specialization} color = '#ffffff'/>
                                        </div>
                                    </Col>
                                    <Col
                                        span={6}
                                        style={{
                                            marginTop: '70px',
                                            color: '#FFFFFF',
                                            // fontFamily: 'Roboto',
                                            fontSize: '15px',
                                        }}
                                    >
                                        <div>
                                            On : {moment(prescriptionData[0].createdAt).format('DD')} -{' '}
                                            {moment(prescriptionData[0].createdAt).format('MMM')} -{' '}
                                            {moment(prescriptionData[0].createdAt).format('YYYY')}
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={{ span: 12 }} span={24}>
                                {prescriptionData[0].fileurl !== null ? (
                                    <Card
                                        className="no-border-card"
                                        style={{ paddingLeft: '160%', cursor: 'pointer' }}
                                        // variant={false}
                                        onClick={() => {
                                            dispatch(passportFileOpenRequest(prescriptionData[0].fileurl));
                                        }}
                                    >
                                        <Avatar shape="square" style={{ cursor: 'pointer' }} size={87} icon="user" src={file} />
                                    </Card>
                                ) : (
                                    <div>
                                        <Row>
                                            <Col span={24} style={{ marginTop: '20px', marginBottom: '20px' }}>
                                                <div
                                                    style={{
                                                        color: '#070707',
                                                        fontFamily: 'Roboto',
                                                        fontSize: '20px',
                                                        letterSpacing: ' -0.0024em',
                                                    }}
                                                >
                                                    <ModalHeading text = 'Symptoms' />
                                                </div>
                                                <div>
                                                    <ModalData text = {prescriptionData[0].symptoms} />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={24} style={{ marginBottom: '20px' }}>
                                                <div
                                                    style={{
                                                        color: '#070707',
                                                        fontFamily: 'Roboto',
                                                        fontSize: '20px',
                                                        letterSpacing: ' -0.0024em',
                                                    }}
                                                >
                                                    <ModalHeading text = 'Diagnosis' />
                                                </div>
                                                <div>
                                                    <ModalData text ={prescriptionData[0].diagnosis} />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={24} style={{ marginBottom: '20px' }}>
                                                <div
                                                    style={{
                                                        color: ' #070707',
                                                        fontFamily: 'Roboto',
                                                        fontSize: '20px',
                                                        letterSpacing: ' -0.0024em',
                                                    }}
                                                >
                                                    <ModalHeading text = 'Prescriptions' />
                                                </div>
                                                <div style={{ paddingTop: '10px' }}>
                                                    {PrescriptionBody}
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </Modal>
                )}

                {/* Health Record Modal */}
                {healthrecord && healthrecord[0] !== null && (
                    <Modal
                        open={visibleHeal}
                        onOk={handleOkHeal}
                        className="bg-bgwhite"
                        onCancel={handleCancelHeal}
                        width={683}
                        footer={false}
                        style={{ marginTop: '-50px' }}
                    >
                        <Row style={{
                            background: '#FD0054',
                            height: '100px',
                            // width: '683px',
                            marginTop: '-20px',
                            marginRight: '-24px',
                            marginLeft: '-24px',
                            borderRadius: '8px 8px 0px 0px',
                            display: 'flex'
                        }}>
                            <Col
                                xs={{ span: 0 }}
                                lg={{ span: 24 }}
                            // style={{
                            //     background: '#FD0054',
                            //     height: '100px',
                            //     width: '683px',
                            //     marginTop: '-29px',
                            //     marginRight: '-50px',
                            //     marginLeft: '-24px',
                            //     borderRadius: '8px 8px 0px 0px',
                            // }}
                            >
                                <Row>
                                    <Col span={16} style={{ marginTop: '32px', marginLeft: '20px' }}>
                                        <div
                                            style={{
                                                color: '#FFFFFF',
                                                fontFamily: 'Roboto',
                                                fontSize: '25px',
                                                letterSpacing: '-0.41px',
                                            }}
                                        >
                                            <ModalTittle text = {healthrecord && healthrecord[0].createdByOrgName} color = '#ffffff' />
                                        </div>
                                    </Col>
                                    <Col
                                        xs={{ span: 0 }}
                                        lg={{ span: 6 }}
                                        style={{
                                            marginTop: '40px',
                                            color: '#FFFFFF',
                                            // fontFamily: 'Roboto',
                                            fontSize: '15px',
                                        }}
                                    >
                                        <div>
                                            On : {moment(healthrecord[0].createdAt).format('DD')} -{' '}
                                            {moment(healthrecord[0].createdAt).format('MMM')} -{' '}
                                            {moment(healthrecord[0].createdAt).format('YYYY')}
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Row>
                                    <Col
                                        xs={{ span: 24 }}
                                        lg={{ span: 16 }}
                                        style={{ marginTop: '2%', marginBottom: '10%' }}
                                    >
                                        <div
                                            style={{
                                                color: ' #4F4F4F',
                                                // fontFamily: 'Roboto',
                                                // fontSize: '21px',
                                                letterSpacing: ' -0.0024em',
                                            }}
                                        >
                                            <ModalHeading text = 'Record Type' />
                                        </div>
                                        <div>
                                            <ModalData text = {healthrecord[0].healthRecType} />
                                        </div>
                                    </Col>
                                    <Col
                                        xs={{ offset: 1, span: 24 }}
                                        lg={{ span: 8, offset: 15 }}
                                        style={{ marginTop: '-10%' }}
                                    >
                                        {healthrecord[0].fileurl !== null ? (
                                            <Card
                                                className="no-border-card"
                                                style={{ paddingLeft: '60%', cursor: 'pointer' }}
                                                // variant={false}
                                                onClick={() => {
                                                    dispatch(passportFileOpenRequest(healthrecord[0].fileurl));
                                                }}
                                            >
                                                <Avatar shape="square" size={87} icon="user" src={file} />
                                            </Card>
                                        ) : (
                                            <div>{HealthRecData}</div>
                                        )}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Modal>
                )}
            </div>
            <CustomSpin spinning={requesting} />
        </Content>
    );
};

// Passport.propTypes = {
//     dispatch: PropTypes.func,
//     passport: PropTypes.object,
//     requesting: PropTypes.object,
//     clickedId: PropTypes.object,
//     clickedIdHeal: PropTypes.object,
//     clickedIdLab: PropTypes.object,
// };

export default Passport;
